module.exports = __webpack_public_path__ + "img/cap-side.9645fbc3.svg";